import React, {useContext} from "react";
import {GlobalContext} from "../../context/GlobalState";
import {css} from "emotion";
import {Link, useRouteMatch} from "react-router-dom";
import {boxStyles, colors, textSizes} from "../../styles/theme";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import PaywallLink from '../PaywallLink';
import isPlanHighEnough from "../../utils/isPlanHighEnough";
import getPlanName from "../../utils/getPlanName";
import plans from "../plans/data/plans";

const SettingsLink = ({route}) => {
  let {url} = useRouteMatch();
  const {currentWorkspace} = useContext(GlobalContext);
  const currentPlan = getPlanName(currentWorkspace);

  let text = "";
  let iconName = "";
  let planNeeded = plans[0].name;

  switch (route) {
    case "account":
      text = "My Account";
      iconName = "user";
      break;

    case "workspace":
      text = "Manage Workspace";
      iconName = "toggle-on";
      break;

    case "users":
      text = "Users";
      iconName = "users";
      planNeeded = 'premium';
      break;

    case "switch":
      text = "Switch Workspace";
      iconName = "sync-alt";
      break;

    case "billing":
      text = "Billing";
      iconName = "credit-card";
      break;

    default:
      text = "none";
      iconName = "play";
  }

  const hasAccess = isPlanHighEnough(currentPlan, planNeeded);

  return (
    hasAccess ? (
      <Link to={`${url}/${route}`} className={container}>
        <FontAwesomeIcon className="icon" icon={iconName}/>
        <p>{text}</p>
        <FontAwesomeIcon className="chevron" icon="chevron-right"/>
      </Link>
    ) : (
      <PaywallLink
        text={text}
        iconName={iconName}
        planNeeded={planNeeded}
        style={container}
      />
    )
  );
};

export default SettingsLink;

const container = css`
  text-decoration: none;
  padding: ${boxStyles.desktopPadding};
  color: ${colors.brandColor};
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${colors.lineBreak};
  
  &:first-child {
    border-top: 0;
  }
  
  &:last-child {
    border-bottom: 0;
  }
  
  .icon {
    text-align: left;
    width: 40px;
    font-size: 20px;
    padding-right: 20px;
  }
  p {
    color: ${colors.titleColor};
    font-size: ${textSizes.subtitle};
    font-weight: 500;
    flex: 1;
  }
  .chevron {
    color: ${colors.placeholderText};
  }
`;
